import axios from 'axios';
import { ApiResponseType } from '../../types/types';
import {
  EventTickets,
  AddTicketForUserResponse,
  UserTickets
} from './Event.types';

export const getEventTicketsAsync = async (
  id: number
): Promise<ApiResponseType<EventTickets[] | undefined>> => {
  const { data } = await axios.get<ApiResponseType<EventTickets[] | undefined>>(
    `/event-ticket/event/${id}`
  );

  return data;
};

export const createEventTicketAsync = async ({
  eventTicketId,
  currencyType,
  networkType
}: {
  eventTicketId: number;
  currencyType: number;
  networkType: number | null;
}): Promise<ApiResponseType<AddTicketForUserResponse>> => {
  const { data } = await axios.post<ApiResponseType<AddTicketForUserResponse>>(
    `/event-ticket`,
    currencyType === 1
      ? { eventTicketId, currencyType, networkType }
      : { eventTicketId, currencyType }
  );

  return data;
};

export const getUserTicketsAsync = async () => {
  const { data } = await axios.get(`/user/tickets`);
  return data.data.userTickets as UserTickets;
};
